import React from 'react';

// Placeholder FriendsExperiences component
export function FriendsExperiences() {
  // Mock data for now
  const mockExperiences = [
    {
      id: 'exp1',
      title: 'Sunset Yoga on the Beach',
      date: '2024-07-10',
      friends: [
        { id: 'u1', name: 'Alex', avatar: 'https://randomuser.me/api/portraits/men/32.jpg' },
        { id: 'u2', name: 'Jamie', avatar: 'https://randomuser.me/api/portraits/women/44.jpg' },
      ],
    },
    {
      id: 'exp2',
      title: 'Art & Wine Night',
      date: '2024-07-15',
      friends: [
        { id: 'u3', name: 'Taylor', avatar: 'https://randomuser.me/api/portraits/men/65.jpg' },
      ],
    },
  ];

  if (mockExperiences.length === 0) {
    return (
      <div className="bg-earth-800/50 p-6 rounded-lg text-center mt-8">
        <h3 className="text-lg font-semibold text-sand-200 mb-2">Experiences Your Friends Are Attending</h3>
        <p className="text-sand-400">No friends are attending experiences yet. Connect Instagram or invite friends to see more here!</p>
      </div>
    );
  }

  return (
    <div className="bg-earth-800/50 p-6 rounded-lg mt-8">
      <h3 className="text-lg font-semibold text-sand-200 mb-4 text-center">Experiences Your Friends Are Attending <span className="ml-2 text-sand-400 text-base font-normal">(Coming Soon)</span></h3>
      <div className="space-y-4">
        {mockExperiences.map(exp => (
          <div key={exp.id} className="flex items-center gap-4 bg-earth-900/80 rounded-lg p-4 shadow">
            <div className="flex-1 min-w-0">
              <div className="font-medium text-sand-100 text-base truncate">{exp.title}</div>
              <div className="text-sand-400 text-xs mb-2">{new Date(exp.date).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' })}</div>
              <div className="flex items-center gap-2 mt-1">
                {exp.friends.map(friend => (
                  <div key={friend.id} className="flex items-center gap-1">
                    <img src={friend.avatar} alt={friend.name} className="w-6 h-6 rounded-full border border-sand-700" />
                    <span className="text-sand-300 text-xs">{friend.name}</span>
                  </div>
                ))}
              </div>
            </div>
            <button
              className="ml-auto bg-sand-100 text-earth-900 rounded-full px-4 py-2 font-semibold shadow opacity-60 cursor-not-allowed"
              disabled
              title="Coming soon!"
              onClick={e => { e.preventDefault(); alert('This feature is coming soon!'); }}
            >
              Join
            </button>
          </div>
        ))}
      </div>
    </div>
  );
} 